<app-breadcrumb [title]="page_name" [breadcrumb]="page_name" [currentUrl]="currentUrl" ></app-breadcrumb>
<!-- section start -->
<section class="section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-3">
                <div class="account-sidebar" (click)="ToggleDashboard()">
                    <a hre="javascript:void(0)" class="popup-btn">
                        {{'my account' | translate}}
                    </a>
                </div>
                <div class="dashboard-left" [class.open]="openDashboard">
                    <div class="collection-mobile-back" (click)="ToggleDashboard()">
                        <span class="filter-back">
                            <i class="fa fa-angle-left" aria-hidden="true"></i> {{'Back' | translate}}
                        </span>
                    </div>
                    <div class="block-content">
                        <ul>
                            <ul>
                                <li class="active"><a data-lng="es" [routerLink]="'/pages/dashboard'">
                                        {{'address' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/my-orders'">
                                        {{'orders' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/my-coupones'">
                                        {{'coupones' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/browse-log'">
                                        {{'browse log' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/profile'">
                                        {{'my profile' | translate}}
                                    </a>
                                </li>
                                <li>
                                    <a data-lng="es" href="javascript:void(0)" (click)="userLogOut()">

                                        {{'logout' | translate}}
                                    </a>
                                </li>

                            </ul>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="dashboard-right">
                    <div class="dashboard">
                        <div class="box-title">
                            <h2>{{'address' | translate}}</h2>
                        </div>
                        <br>
                        <div class="box-content">
                            <p [innerHTML]="brief"></p>

                        </div>
                        <div class="box-account box-info">
                            <div class="box-title">
                                <h2>{{'Account Information' | translate}}</h2>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="box">

                                        <div class="box-content">
                                            <h6 *ngIf="currentUser['user_name']">{{'Full Name' | translate}} :
                                                {{currentUser['user_name']}} {{currentUser['last_name']}}</h6>
                                            <h6>{{'mobile' | translate}} : {{currentUser['mobile']}}</h6>
                                            <h6 *ngIf="currentUser['email']"> {{'Email' | translate}} :
                                                {{currentUser['email']}}</h6>
                                            <h6 *ngIf="currentUser['address']"> {{'Address' | translate}} : <span
                                                    [innerHTML]="currentUser['address']"></span></h6>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div>
                                <br>
                                <div class="box-title ">
                                    <br>

                                    <h2>{{'Shipping addresses' | translate}}</h2>
                                </div>
                                <div class="box-title" [class.text-start]="Common.isRtl">


                                    <button type="button" class="btn btn-primary quantity-right-plus border-test"
                                        data-type="plus" (click)="openModal(0,'add')">
                                        <i class="fa fa-plus"></i> {{'add_address' | translate}}
                                    </button>
                                </div>

                                <div class="box col-md-12">
                                    <br>
                                    <div class="row">

                                        <div class="col-md-12">

                                            <div class="dashboard-table table-style table-responsive">
                                                <table class="table table-striped table-bordered custom-border-color">
                                                    <thead class="thead-light">
                                                        <tr>
                                                            <th scope="col" class="text-center">{{ 'City' | translate }}
                                                            </th>
                                                            <th scope="col" class="text-center">{{ 'District' |
                                                                translate }}
                                                            </th>
                                                            <th scope="col" class="text-center">{{ 'title' | translate
                                                                }}</th>
                                                            <th scope="col" class="text-center">{{ 'Full Name' |
                                                                translate }}</th>
                                                            <th scope="col" class="text-center">{{ 'account phone' |
                                                                translate }}</th>
                                                            <th scope="col" class="text-center">{{ 'ACTION' | translate
                                                                }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody *ngFor="let address of myAddresess let i=index">
                                                        <tr>
                                                            <td class="text-center">
                                                                {{ address.city_name }}
                                                                <h4 class="text-center" *ngIf="address.is_default == 1">
                                                                    <span
                                                                        class="text-white badge rounded-pill bg-success">{{
                                                                        'default' | translate }}</span>
                                                                </h4>
                                                            </td>
                                                            <td class="text-center">
                                                                {{ address.district_name }}
                                                                <span class="text-center text-danger"
                                                                    *ngIf="!address.district_name">
                                                                    {{'district error'|translate}}</span>
                                                            </td>
                                                            <td class="text-center">
                                                                {{ address.title }}

                                                            </td>
                                                            <td class="text-center" style="width: 170px;">
                                                                {{ address.user_name?
                                                                address.user_name + ' ' + address.last_name : '' }}
                                                                <p class="text-center text-danger"
                                                                    *ngIf=" !address.user_name">
                                                                    {{'name error'|translate}}</p>
                                                            </td>
                                                            <td class="text-center">
                                                                <p class="m-0 text-center">{{ address.mobile ?
                                                                    address.mobile : '' }}</p>
                                                                <p class="m-0 text-center">{{ address.mobile_2 ?
                                                                    address.mobile_2 : '' }}</p>
                                                                <p class="text-center text-danger"
                                                                    *ngIf="!address.mobile">
                                                                    {{'mobile error'|translate}}</p>
                                                            </td>
                                                            <td class="text-center" rowspan="2">
                                                                <div>
                                                                    <a href="javascript:void(0)" class="icon"
                                                                        title="حذف"
                                                                        (click)="opendeleteModal(address.id)">
                                                                        <i class="ti-trash"></i>
                                                                    </a>
                                                                    <a href="javascript:void(0)" class="icon"
                                                                        class="ml-25" title="تعديل"
                                                                        (click)="openModal(i,'edit')">
                                                                        <i class="ti-pencil text-success"></i>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr style="background-color: rgba(0, 0, 0, 0.05); width: 100%;"
                                                            *ngIf=" !address.user_name || !address.mobile || !address.district_name">
                                                            <td colspan="5" class="error-table"
                                                                style=" border-top: 1px solid #ded0cd !important;">
                                                                <p class="my-1 text-center text-danger">
                                                                    {{'address edit'|translate}}</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section end -->



<ng-template class="theme-modal" #newsletter let-modal>
    <div class="modal-content">
        <div class="modal-body modal7" style="background-image: unset;">
            <div class="p-0 container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="modal-bg">
                            <button type="button" class="close" aria-label="Close"
                                (click)="modal.dismiss('Cross click')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="offer-content" *ngIf="step1">
                                <div class="circle-icon">
                                    <i class="fa fa-plus"></i>
                                </div>
                                <h2> {{'add' | translate}} {{'title' | translate}} </h2>

                                <br>
                                <div class="row">
                                    <div class="my-2 col-12">
                                        <div class="inputs">
                                            <p class="single-input" [dir]="Common.isRtl?'rtl':'ltr'">
                                                <input type="text" class="w-100" [(ngModel)]="user_name" placeholder=" "
                                                    [dir]="Common.isRtl?'rtl':'ltr'">
                                                <label [class.label-rtl]="Common.isRtl">
                                                    {{'first name'|translate}} </label>
                                                <i class="fa fa-solid fa-user p-icon"></i>
                                            </p>

                                        </div>
                                    </div>
                                    <!-- <div class="my-2 col-6">
                                        <div class="inputs">
                                            <p class="single-input" [dir]="Common.isRtl?'rtl':'ltr'">
                                                <input type="text" class="w-100" [(ngModel)]="last_name" placeholder=" "
                                                    [dir]="Common.isRtl?'rtl':'ltr'">
                                                <label [class.label-rtl]="Common.isRtl">
                                                    {{'last name'|translate}} </label>
                                                <i class="fa fa-solid fa-user p-icon"></i>
                                            </p>
                                        </div>
                                    </div> -->
                                    <p class="errorOccurred" *ngIf="successUser_name">{{errorUserNameMessage}}</p>
                                    <div class="my-2 col-12">
                                        <div class="inputs">
                                            <p class="single-input mobile-p mobile-input"
                                                [dir]="Common.isRtl?'rtl':'ltr'">
                                                <input type="tel" class="w-100 form-control" [(ngModel)]="mobile_data"
                                                    [placeholder]="phoneplaceholder" (ngModelChange)="checkLength()"
                                                    [class.is-valid]="mobileIsValid"
                                                    [class.is-invalid]="mobileIsInValid">
                                                <label [class.label-rtl]="Common.isRtl">
                                                    {{'enter phone'|translate}} </label>
                                            </p>
                                            <div class="mobile-code">
                                                <span>{{country_code}}+</span>
                                                <img [src]="image_mobile" class="mb-0" alt="flag-code">
                                            </div>
                                        </div>
                                        <span class="errorOccurred" *ngIf="successMobile">{{errorMobileMessage}}
                                        </span>

                                    </div>
                                    <div class="my-2 col-12">
                                        <div class="inputs">
                                            <p class="single-input mobile-p mobile-input"
                                                [dir]="Common.isRtl?'rtl':'ltr'">
                                                <input type="tel" class="w-100 form-control" [(ngModel)]="mobile2_data"
                                                    [placeholder]="phone2placeholder" (ngModelChange)="checkLength2()"
                                                    [class.is-valid]="mobile2IsValid"
                                                    [class.is-invalid]="mobile2IsInValid">
                                                <label [class.label-rtl]="Common.isRtl">
                                                    {{'enter phone2'|translate}} </label>
                                            </p>
                                            <div class="mobile-code">
                                                <span>{{country_code}}+</span>
                                                <img [src]="image_mobile" class="mb-0" alt="flag-code">
                                            </div>
                                        </div>
                                        <span class="errorOccurred" *ngIf="successMobile2">{{errorMobileMessage2}}
                                        </span>
                                    </div>
                                </div>
                                <div class="row">

                                    <div class="form-group col-md-12 col-sm-12 col-xs-12" *ngIf="country_id !='' ">
                                        <div class="gap-3 d-flex">
                                            <div class="mb-2 field-label">{{'City' | translate}}</div>
                                            <div *ngIf="checkoutForm.controls.city.touched && checkoutForm.controls.city.errors?.required"
                                                class="text text-danger">
                                                {{'faild is required' | translate}}
                                            </div>
                                        </div>
                                        <select name="city_id" [(ngModel)]="city_id" class="form-control"
                                            (ngModelChange)="onChangeCity(city_id)"
                                            [formControl]="checkoutForm.controls['city']">
                                            <option value="" selected>{{'city select' | translate}}</option>
                                            <option [value]="city.id" *ngFor="let city of cities">{{city.pla_name}}
                                            </option>
                                        </select>

                                    </div>

                                    <div class="form-group col-md-12 col-sm-12 col-xs-12" *ngIf="city_id !='' ">
                                        <div class="gap-3 d-flex">
                                            <div class="mb-2 field-label">{{'District' | translate}}</div>
                                            <div *ngIf="checkoutForm.controls.District.touched && checkoutForm.controls.District.errors?.required"
                                                class="text text-danger">
                                                {{'faild is required' | translate}}
                                            </div>
                                        </div>
                                        <select name="district_id" [(ngModel)]="district_id" class="form-control"
                                            [formControl]="checkoutForm.controls['District']">
                                            <option value="" selected>{{'district select' | translate}}</option>
                                            <option [value]="district.id" *ngFor="let district of Districts">
                                                {{district.pla_name}}
                                            </option>
                                        </select>

                                    </div>

                                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                        <div class="gap-3 d-flex">
                                            <div class="mb-2 field-label" style="text-align: start;">
                                                {{'title' | translate}}
                                            </div>
                                            <div *ngIf="checkoutForm.controls.title.touched && checkoutForm.controls.title.errors?.required"
                                                class="text text-danger">
                                                {{'faild is required' | translate}}
                                            </div>
                                        </div>
                                        <input type="text" [(ngModel)]="title" name="title"
                                            [formControl]="checkoutForm.controls['title']" value=""
                                            placeholder="{{'title' | translate}}" autocomplete="off"
                                            class="form-control">
                                        <div class="mt-2 text text-info text-start">
                                            {{'Title Details' | translate}}
                                        </div>

                                        <div *ngIf="checkoutForm.controls.title.touched && checkoutForm.controls.title.errors?.maxlength"
                                            class="text text-danger">
                                            Maximum 255 character
                                        </div>
                                    </div>

                                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                        <div class="d-flex align-items-start">
                                            <label id="example-radio-group-label">{{'default address' | translate}}
                                                :</label>
                                            <mat-radio-group aria-labelledby="example-radio-group-label"
                                                class="flex-row example-radio-group d-flex" [(ngModel)]="is_default"
                                                [formControl]="checkoutForm.controls['is_default']">
                                                <mat-radio-button class="example-radio-button" value="1">
                                                    {{'Yes' |translate}}
                                                </mat-radio-button>
                                                <mat-radio-button class="example-radio-button" value="0">
                                                    {{'No' | translate}}
                                                </mat-radio-button>
                                            </mat-radio-group>
                                        </div>

                                    </div>
                                </div>

                                <div class="p-0 border-0 modal-footer">
                                    <button #styledButton type="button" class="m-0 mr-auto btn save-btn w-100"
                                        (click)="addAddress()" [style.color]="'var(--theme-default-text)'">{{'save address' |
                                        translate}}</button>
                                </div>
                            </div>
                            <div class="offer-content" *ngIf="step4">
                                <div class="circle-icon">
                                    <i class="fa fa-plus"></i>
                                </div>
                                <h2> {{'Edit' | translate}} {{'title' | translate}} </h2>

                                <br>
                                <div class="row">
                                    <div class="my-2 col-12">
                                        <div class="inputs">
                                            <p class="single-input" [dir]="Common.isRtl?'rtl':'ltr'">
                                                <input type="text" class="w-100" [(ngModel)]="user_name" placeholder=" "
                                                    [dir]="Common.isRtl?'rtl':'ltr'">
                                                <label [class.label-rtl]="Common.isRtl">
                                                    {{'first name'|translate}} </label>
                                                <i class="fa fa-solid fa-user p-icon"></i>
                                            </p>

                                        </div>
                                    </div>
                                    <!-- <div class="my-2 col-6">
                                        <div class="inputs">
                                            <p class="single-input" [dir]="Common.isRtl?'rtl':'ltr'">
                                                <input type="text" class="w-100" [(ngModel)]="last_name" placeholder=" "
                                                    [dir]="Common.isRtl?'rtl':'ltr'">
                                                <label [class.label-rtl]="Common.isRtl">
                                                    {{'last name'|translate}} </label>
                                                <i class="fa fa-solid fa-user p-icon"></i>
                                            </p>
                                        </div>
                                    </div> -->
                                    <p class="errorOccurred" *ngIf="successUser_name">{{errorUserNameMessage}}</p>
                                    <div class="my-2 col-12">
                                        <div class="inputs">
                                            <p class="single-input mobile-p mobile-input"
                                                [dir]="Common.isRtl?'rtl':'ltr'">
                                                <input type="tel" class="w-100 form-control" [(ngModel)]="mobile_data"
                                                    [placeholder]="phoneplaceholder" (ngModelChange)="checkLength()"
                                                    [class.is-valid]="mobileIsValid"
                                                    [class.is-invalid]="mobileIsInValid">
                                                <label [class.label-rtl]="Common.isRtl">
                                                    {{'enter phone'|translate}} </label>
                                            </p>
                                            <div class="mobile-code">
                                                <span>{{country_code}}+</span>
                                                <img [src]="image_mobile" class="mb-0" alt="flag-code">
                                            </div>
                                        </div>
                                        <span class="errorOccurred" *ngIf="successMobile">{{errorMobileMessage}}
                                        </span>

                                    </div>
                                    <div class="my-2 col-12">
                                        <div class="inputs">
                                            <p class="single-input mobile-p mobile-input"
                                                [dir]="Common.isRtl?'rtl':'ltr'">
                                                <input type="tel" class="w-100 form-control" [(ngModel)]="mobile2_data"
                                                    [placeholder]="phone2placeholder" (ngModelChange)="checkLength2()"
                                                    [class.is-valid]="mobile2IsValid"
                                                    [class.is-invalid]="mobile2IsInValid">
                                                <label [class.label-rtl]="Common.isRtl">
                                                    {{'enter phone2'|translate}} </label>
                                            </p>
                                            <div class="mobile-code">
                                                <span>{{country_code}}+</span>
                                                <img [src]="image_mobile" class="mb-0" alt="flag-code">
                                            </div>
                                        </div>
                                        <span class="errorOccurred" *ngIf="successMobile2">{{errorMobileMessage2}}
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12" *ngIf="country_id !='' ">
                                        <div class="gap-3 d-flex">
                                            <div class="mb-2 field-label">{{'City' | translate}}</div>
                                            <div *ngIf="checkoutForm.controls.city.touched && checkoutForm.controls.city.errors?.required"
                                                class="text text-danger">
                                                {{'faild is required' | translate}}
                                            </div>
                                        </div>
                                        <select name="city_id" [(ngModel)]="city_id" (change)="onChangeCity(city_id)"
                                            class="form-control" [formControl]="checkoutForm.controls['city']">
                                            <option value="" selected>{{'Select' | translate}}</option>
                                            <option [value]="city.id" *ngFor="let city of cities">{{city.pla_name}}
                                            </option>
                                        </select>

                                    </div>
                                    <div class="form-group col-md-12 col-sm-12 col-xs-12" *ngIf="city_id !='' ">
                                        <div class="gap-3 d-flex">
                                            <div class="mb-2 field-label">{{'District' | translate}}</div>
                                            <div *ngIf="checkoutForm.controls.District.touched && checkoutForm.controls.District.errors?.required"
                                                class="text text-danger">
                                                {{'faild is required' | translate}}
                                            </div>
                                        </div>
                                        <select name="district_id" [(ngModel)]="district_id" class="form-control"
                                            [formControl]="checkoutForm.controls['District']">
                                            <option value="" selected>{{'Select district' | translate}}</option>
                                            <option [value]="district.id" *ngFor="let district of Districts">
                                                {{district.pla_name}}
                                            </option>
                                        </select>

                                    </div>

                                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                        <div class="gap-3 d-flex">
                                            <div class="mb-2 field-label" style="text-align: start;">
                                                {{'title' | translate}}
                                            </div>
                                            <div *ngIf="checkoutForm.controls.title.touched && checkoutForm.controls.title.errors?.required"
                                                class="text text-danger">
                                                {{'faild is required' | translate}}
                                            </div>
                                        </div>
                                        <input type="text" [(ngModel)]="title" name="title"
                                            [formControl]="checkoutForm.controls['title']" value=""
                                            placeholder="{{'title' | translate}}" autocomplete="off"
                                            class="form-control">
                                        <div class="mt-2 text text-info text-start">
                                            {{'Title Details' | translate}}
                                        </div>

                                        <div *ngIf="checkoutForm.controls.title.touched && checkoutForm.controls.title.errors?.maxlength"
                                            class="text text-danger">
                                            Maximum 255 character
                                        </div>
                                    </div>

                                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                                        <div class="d-flex align-items-start">
                                            <label id="example-radio-group-label">{{'default address' | translate}}
                                                :</label>
                                            <mat-radio-group aria-labelledby="example-radio-group-label"
                                                class="flex-row example-radio-group d-flex" [(ngModel)]="is_default"
                                                [formControl]="checkoutForm.controls['is_default']">
                                                <mat-radio-button class="example-radio-button" value="1">
                                                    {{'Yes' |translate}}
                                                </mat-radio-button>
                                                <mat-radio-button class="example-radio-button" value="0">
                                                    {{'No' | translate}}
                                                </mat-radio-button>
                                            </mat-radio-group>
                                        </div>

                                    </div>
                                </div>

                                <div class="p-0 border-0 modal-footer">
                                    <button #styledButton type="button" class="m-0 mr-auto btn save-btn w-100"
                                        (click)="editAddress()" [style.color]="'var(--theme-default-text)'">{{'edit address' |
                                        translate}}</button>
                                </div>
                            </div>

                            <div class="offer-content" *ngIf="step2">

                                <h2 *ngIf="addStep">{{'add' | translate}} {{'title' | translate}} </h2>
                                <h2 *ngIf="editStep">{{'Edit' | translate}} {{'title' | translate}} </h2>

                                <div class="category-image">
                                    <img src="assets/images/slider/loader12.gif" alt="" class="w-auto">
                                </div>

                                <br>
                                <div class="modal-footer">
                                    <br>
                                    <br>
                                </div>
                            </div>

                            <div class="offer-content" *ngIf="step3">
                                <div class="circle-icon-check">
                                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                                </div>

                                <h2 class="text-success" *ngIf="addStep">{{'success add' | translate}} {{'title' |
                                    translate}}
                                    {{'Successfully'
                                    | translate}} </h2>
                                <h2 class="text-success" *ngIf="editStep">{{'Edit' | translate}} {{'title' | translate}}
                                    {{'Successfully'
                                    | translate}} </h2>


                                <br>
                                <div class="text-center border-top">
                                    <br>
                                    <button type="button" class="mr-auto btn btn-primary footer-btn" aria-label="Close"
                                        (click)="modal.dismiss('Cross click')">{{'button confirm'|translate}}</button>
                                </div>
                            </div>


                            <div class="offer-content" *ngIf="step11">
                                <div class="circle-icon">
                                    <i class="ti-info-alt"></i>

                                </div>
                                <h2>{{'Delete Address' | translate}} </h2>
                                <h4> {{'Do you want to' | translate}} {{'Delete Address' | translate}}</h4>
                                <br>

                                <div class="modal-footer">
                                    <button type="button" class="mr-auto btn btn-primary"
                                        (click)="deleteAddress(this.delete_address_id)">{{'Delete' |
                                        translate}}</button>
                                    <button type="button" class="btn btn-secondary" aria-label="Close"
                                        (click)="modal.dismiss('Cross click')">{{'cancel' | translate}}</button>
                                </div>
                            </div>

                            <div class="offer-content" *ngIf="step22">

                                <h2>{{'Delete Address' | translate}}</h2>

                                <div class="category-image">
                                    <img src="assets/images/slider/loader12.gif" alt="" class="w-auto">
                                </div>

                                <br>
                                <div class="modal-footer">
                                    <br>
                                    <br>
                                </div>
                            </div>

                            <div class="offer-content" *ngIf="step33">
                                <div class="circle-icon-check">
                                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                                </div>

                                <h2 class="text-success">{{'Delete Address' | translate}} {{'Successfully' | translate}}
                                </h2>


                                <br>
                                <div class="modal-footer">
                                    <br>
                                    <button type="button" class="mr-auto btn btn-primary" aria-label="Close"
                                        (click)="modal.dismiss('Cross click')">Ok</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</ng-template>

<!-- login -->
<section #login class="full-sidebar" *ngIf="loginclicked">
    <div class="shadow login-sidebar">
        <i class="ti-close login-icon" (click)="close()"></i>
        <app-fast-login (step5Reached)="onStep5Reached()"
            (stepSuccessReached)="onstepSuccessReached()"></app-fast-login>
    </div>
</section>
